import React from 'react';

import { Button, message } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Formik, ErrorMessage } from 'formik';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { sendSupportMail } from '../../hooks/settings';

const SupportConfigFormWrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    label:first-child {
      margin-right: 10px;
    }

    button {
      margin-top: 20px;
    }
  }
`;

const FormLabel = styled.label`
  font-size: 12px;
`;

const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;

  @media (min-width: 1024px) {
    min-width: 600px;
  }

  select {
    padding: 4px 20px 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    touch-action: manipulation;
    appearance: none;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' standalone='no'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg t='1597601650772' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='1210' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%3C/style%3E%3C/defs%3E%3Cpath d='M726.652801 429.305603 297.347199 429.305603 512.193405 638.156258Z' p-id='1211'%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right;

    &:focus {
      border-color: #40a9ff;
      border-right-width: 1px !important;
      outline: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    &:hover {
      border-color: #40a9ff;
      border-right-width: 1px !important;
    }
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const FormInputGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;

  > div:first-child {
    margin-right: 10px;
  }
`;

const MessageBox = styled.div`
  color: red;
  font-size: 12px;
`;

const SupportConfigForm = ({ initialValues }) => {
  const history = useHistory();

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const errors = {};

        if (!values.message) errors.message = 'O campo mensagem é obrigatório.';

        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(async () => {
          let data = null;
          data = await sendSupportMail(values);

          if (data !== null) {
            if (data.type === 'success') {
              message.success('Mensagem enviada com sucesso!');
              setTimeout(() => {
                history.goBack();
              }, 1000);
            } else {
              message.error('Não foi possível realizar a operação. Certifique-se de que os campos foram corretamente preenchidos.');
            }
          } else {
            message.error('Não foi possível realizar a operação. Certifique-se de que os campos foram corretamente preenchidos.');
          }
          setSubmitting(false);
        }, 400);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
        return (
          <SupportConfigFormWrapper>
            <form onSubmit={handleSubmit}>
              <FormInputWrapper>
                <FormLabel>{T('Subject')}:</FormLabel>
                <select name="subject" label="subject" as="select" onChange={handleChange} onBlur={handleBlur} value={values.subject} required>
                  <option value="general">{T('General Subjects')}</option>
                  <option value="complaint">{T('Complaint')}</option>
                  <option value="suggestion">{T('Suggestion')}</option>
                </select>
                <ErrorMessage name="subject" component={MessageBox} />
              </FormInputWrapper>
              <FormInputWrapper>
                <FormLabel>{T('Message')}</FormLabel>
                <TextArea name="message" label="message" onChange={handleChange} onBlur={handleBlur} value={values.message} maxLength={255} rows={4} />
                <ErrorMessage name="message" component={MessageBox} />
              </FormInputWrapper>
              <Button type="primary" disabled={isSubmitting} onClick={handleSubmit}>
                {T('Submit')}
              </Button>
            </form>
          </SupportConfigFormWrapper>
        );
      }}
    </Formik>
  );
};

export default SupportConfigForm;
